import { render, staticRenderFns } from "./NuevoIncidente.vue?vue&type=template&id=8270f142&scoped=true"
import script from "./NuevoIncidente.vue?vue&type=script&lang=js"
export * from "./NuevoIncidente.vue?vue&type=script&lang=js"
import style0 from "./NuevoIncidente.vue?vue&type=style&index=0&id=8270f142&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8270f142",
  null
  
)

export default component.exports